import React, { useState } from "react";
import { useParams } from "react-router";
import AliianceManagerLayout from "../../../components/layouts/AliianceManagerLayout";
import AdminPageContainer from "../../../components/AdminPageContainer";
import AddFE from "../../../Containers/Vendor/AddFE/AddFE";
import Breadcrumb from "../../../components/common/Breadcrumb";
import VendorSelect from "./VendorSelect";

// Alliance Manager: add a field executive under a vendor.
// Vendor comes from the route (vendor details page) or is picked from the dropdown (side menu).
const AddVendorFEPage = () => {
  const { id } = useParams();
  const [vendor, setVendor] = useState(null);
  const vendorId = id || vendor?.id;

  const breadcrumbs = id
    ? [
        { title: "Home", link: "/alliance-manager/dashboard", isActive: true },
        { title: "Vendors", link: "/alliance-manager/vendors", isActive: true },
        {
          title: "Vendor Details",
          link: `/alliance-manager/vendors/details/${id}`,
          isActive: true,
        },
        { title: "Add Field Executive", isActive: false },
      ]
    : [
        { title: "Home", link: "/alliance-manager/dashboard", isActive: true },
        { title: "Field Executives Lists", link: "/alliance-manager/field-executives", isActive: true },
        { title: "Add Field Executive", isActive: false },
      ];

  const vendorPicker = !id && (
    <VendorSelect value={vendor} onChange={setVendor} />
  );

  return (
    <AliianceManagerLayout>
      <AdminPageContainer>
        {vendorId ? (
          // key remounts the form so the executive list and fields reset on vendor change
          <AddFE
            key={vendorId}
            vendorIds={vendorId}
            breadcrumbs={breadcrumbs}
            vendorPicker={vendorPicker}
          />
        ) : (
          <div id="main" role="main">
            <div id="content">
              <Breadcrumb items={breadcrumbs} />
              {vendorPicker}
            </div>
          </div>
        )}
      </AdminPageContainer>
    </AliianceManagerLayout>
  );
};

export default AddVendorFEPage;
